import { useEffect, useRef, useState } from "react";
import { Eye, Pencil, Check, Loader2 } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import IaMessage from "@/components/ia/IaMessage";
import { saveReportContent } from "@/lib/reports";
import { cn } from "@/lib/utils";

export default function ReportEditor({ dossierId, sessionId, kind, content, onChange, readOnly }) {
    const [mode, setMode] = useState("preview");
    const [status, setStatus] = useState("");
    const timer = useRef(null);
    const dirty = useRef(false);

    useEffect(() => () => clearTimeout(timer.current), []);

    function edit(text) {
        onChange(text);
        dirty.current = true;
        setStatus("saving");
        clearTimeout(timer.current);
        timer.current = setTimeout(async () => {
            try { await saveReportContent(dossierId, sessionId, kind, { content: text }); setStatus("saved"); dirty.current = false; }
            catch { setStatus("error"); }
        }, 1200);
    }

    return (
        <div data-testid={`report-editor-${kind}`} className="space-y-2">
            <div className="flex items-center gap-1 text-xs">
                <button type="button" data-testid="editor-mode-preview" onClick={() => setMode("preview")} className={cn("inline-flex items-center gap-1 rounded-full px-3 py-1 border", mode === "preview" ? "bg-foreground text-background border-foreground" : "border-border text-muted-foreground hover:text-foreground")}><Eye className="h-3.5 w-3.5" /> Lecture</button>
                {!readOnly && <button type="button" data-testid="editor-mode-edit" onClick={() => setMode("edit")} className={cn("inline-flex items-center gap-1 rounded-full px-3 py-1 border", mode === "edit" ? "bg-foreground text-background border-foreground" : "border-border text-muted-foreground hover:text-foreground")}><Pencil className="h-3.5 w-3.5" /> Éditer</button>}
                <span data-testid="editor-status" className="ml-auto text-muted-foreground flex items-center gap-1">
                    {status === "saving" && <><Loader2 className="h-3 w-3 animate-spin" /> Enregistrement…</>}
                    {status === "saved" && <><Check className="h-3 w-3 text-emerald-600" /> Enregistré</>}
                    {status === "error" && <span className="text-destructive">Échec de l'enregistrement</span>}
                </span>
            </div>
            {mode === "edit" && !readOnly ? (
                <Textarea data-testid="editor-textarea" value={content} onChange={(e) => edit(e.target.value)} rows={24} className="bg-background font-mono text-[13px] leading-relaxed resize-none h-[600px] overflow-y-auto" />
            ) : (
                <div data-testid="report-preview-scroll" className="h-[600px] overflow-y-auto rounded-md border border-border bg-background px-4 py-3">
                    <IaMessage message={{ role: "assistant", content }} />
                </div>
            )}
        </div>
    );
}
